import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

import { API } from "@/lib/api";

function getVisitorId() {
  let id = localStorage.getItem("fyb_visitor_id");
  if (!id) {
    id = "v_" + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem("fyb_visitor_id", id);
  }
  return id;
}

export default function TrackingProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = {
      page: location.pathname,
      referrer: document.referrer || "",
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || "",
      visitor_id: getVisitorId(),
    };

    // Don't track admin pages
    if (location.pathname.startsWith("/admin")) return;

    axios.post(`${API}/track`, data).catch(() => {});
  }, [location.pathname, location.search]);

  return children;
}
